export default __webpack_public_path__ + "static/media/crab-agnolotti.52272b07.jpg";